import { render } from "./AdSets.vue?vue&type=template&id=081237be"
import script from "./AdSets.vue?vue&type=script&lang=js"
export * from "./AdSets.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__